import React from "react";
import Star from "./Star";

export type ILabelAndStars = {
    title?: string;
    starCount: 1 | 2 | 3 | 4 | 5;
};

const LabelAndStars = ({ title, starCount }: ILabelAndStars) => {
    return (
        <div className="LabelAndStars inline-block">
            {title && <div className="LabelAndStars-title tet-info-light mb-1 text-overline font-bold uppercase tracking-overline">{title}</div>}
            <div className="LabelAndStars-stars flex items-center rounded-lg bg-background-contrast py-1 px-2">
                {Array.from(Array(5)).map((_x, ind) => (
                    <Star key={ind} isGold={starCount >= ind + 1} />
                ))}
            </div>
        </div>
    );
};

export default LabelAndStars;
